export default __webpack_public_path__ + "static/media/section2_Bg.a99fb8f1.png";